import { createSelector } from 'reselect';

export const getInvoices = createSelector(
  (state) => state.contractorsInvoices.data.invoices,
  (invoices) => {
    return invoices;
  }
);

export const getPaginationInfo = createSelector(
  (state) => state.contractorsInvoices.ui.paginationInfo,
  (paginationInfo) => {
    return paginationInfo;
  }
);

export const searchTextSelector = createSelector(
  (state) => state.contractorsInvoices.ui.searchText,
  (searchText) => {
    return searchText;
  }
);

export const vendorsInvoicesSelector = createSelector(
  (state) => state.contractorsInvoices.data.vendorInvoices,
  (vendorInvoices) => {
    return vendorInvoices;
  }
);

export const vendorsInvoicesPaginationInfoSelector = createSelector(
  (state) => state.contractorsInvoices.ui.vendorInvoicesPaginationInfo,
  (vendorInvoicesPaginationInfo) => {
    return vendorInvoicesPaginationInfo;
  }
);

export const searchFiltersSelector = createSelector(
  (state) => state.contractorsInvoices.ui.searchFilters,
  (searchFilters) => {
    return searchFilters;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/contractors-invoices/store/selectors.js